import React from 'react'
import { BaseRendererProps } from '../types/BaseRenderer'
import { RendererClassNames } from '../definitions'

const RollupRenderer: React.FC<BaseRendererProps> = ({ value }) => {
  if (value instanceof Object) {
    return null
  }

  return <div className={RendererClassNames.LOOKUP}>{value}</div>
}

export default React.memo(RollupRenderer)
